import { ApiEpBilling } from "@smp/api";
import { Await } from "@smp/utils";
import { useQuery, UseQueryOptions } from "react-query";

const KEY = "ep.billing.product.token_package";

export const useQueryBillingTokenPackageList = (
  options?: Omit<
    UseQueryOptions<
      Await<ReturnType<typeof ApiEpBilling.Product.TokenPackage.list>>
    >,
    "queryKey" | "queryFn"
  >,
) =>
  useQuery<Await<ReturnType<typeof ApiEpBilling.Product.TokenPackage.list>>>(
    [KEY],
    () => ApiEpBilling.Product.TokenPackage.list(),
    options,
  );

useQueryBillingTokenPackageList.KEY = KEY;
